"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _checkTypes = _interopRequireDefault(require("check-types"));

var _FormElement = _interopRequireDefault(require("../01_atoms/FormElement"));

var _FormElementGroup = _interopRequireDefault(require("../01_atoms/FormElementGroup"));

var _Button = _interopRequireDefault(require("../01_atoms/Button"));

var _TitledContainer = _interopRequireDefault(require("../01_atoms/TitledContainer"));

var _AddressFormComponent = _interopRequireDefault(require("./AddressFormComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var emptyAddress = function emptyAddress() {
  return {
    line1: '',
    line2: '',
    city: '',
    zip: '',
    country: ''
  };
};

var CovidInfoWidget = /*#__PURE__*/function (_Component) {
  _inherits(CovidInfoWidget, _Component);

  var _super = _createSuper(CovidInfoWidget);

  function CovidInfoWidget() {
    var _this;

    _classCallCheck(this, CovidInfoWidget);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      originAddress: emptyAddress(),
      destinationAddress: emptyAddress()
    };
    return _this;
  }

  _createClass(CovidInfoWidget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Apply default value on mount if any
      var defaultValue = this.props.defaultValue;

      if (_checkTypes["default"].nonEmptyObject(defaultValue)) {
        this.setState({
          originAddress: defaultValue.originAddress || emptyAddress(),
          destinationAddress: defaultValue.destinationAddress || emptyAddress()
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$validateD = _this$props.validateData,
          validateData = _this$props$validateD === void 0 ? function () {
        return true;
      } : _this$props$validateD,
          _this$props$onSubmit = _this$props.onSubmit,
          onSubmit = _this$props$onSubmit === void 0 ? function () {} : _this$props$onSubmit,
          translatorForNamespace = _this$props.translatorForNamespace;
      var _this$state = this.state,
          originAddress = _this$state.originAddress,
          destinationAddress = _this$state.destinationAddress;
      var t = translatorForNamespace('CovidInfoWidget');
      return /*#__PURE__*/_react["default"].createElement(_TitledContainer["default"], {
        title: t('Covid information')
      }, /*#__PURE__*/_react["default"].createElement(_FormElementGroup["default"], {
        title: t('Your Origin Address')
      }, /*#__PURE__*/_react["default"].createElement(_FormElement["default"], null, /*#__PURE__*/_react["default"].createElement(_AddressFormComponent["default"], {
        address: originAddress,
        onChange: function onChange(d) {
          return _this2.setState({
            originAddress: d
          });
        },
        translatorForNamespace: translatorForNamespace
      }))), /*#__PURE__*/_react["default"].createElement(_FormElementGroup["default"], {
        title: t('Your Destination Address')
      }, /*#__PURE__*/_react["default"].createElement(_FormElement["default"], null, /*#__PURE__*/_react["default"].createElement(_AddressFormComponent["default"], {
        address: destinationAddress,
        onChange: function onChange(d) {
          return _this2.setState({
            destinationAddress: d
          });
        },
        translatorForNamespace: translatorForNamespace
      }))), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        style: {
          marginTop: 25
        },
        disabled: !validateData(this.state),
        primary: true,
        fluid: true,
        onClick: function onClick() {
          return onSubmit(_this2.state);
        }
      }, t('Confirm details')));
    }
  }]);

  return CovidInfoWidget;
}(_react.Component);

var _default = CovidInfoWidget;
exports["default"] = _default;